import { API, authClient } from "../index";

export const postPartidaCategory = async (category, accessToken) => {
	return authClient(accessToken).post(`${API}/item-categories`, category);
};

export const getPartidaCategories = (accessToken) => {
	return authClient(accessToken).get(`${API}/item-categories`);
};

export const getPartidaCategoryById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/item-categories/${id}`);
};

export const updatePartidaCategory = async (id, category, accessToken) => {
	return authClient(accessToken).put(
		`${API}/item-categories/${id}`,
		category
	);
};

export const deletePartidaCategory = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/item-categories/${id}`);
};
